import React from 'react'
import Header from './Header';
import { Redirect, withRouter } from 'react-router-dom';
import { authService } from './auth';
import "./project/container/Project/css/main-projects.min.css";
import LeftPanel from "./LeftPanel";
import CentralPanel from "./CentralPanel";
import RightPanel from "./RightPanel";
import alertPopUp from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import { getFormattedDate } from './Donation/DonationCommonFunction';
import PeopleNatureAwardModal from './PeopleNatureAwardModal';
import HomePageBadge from './Badge/HomePageBadge';
import { setProfileCompletionReminderDetails } from './reducer/profile/ProfileReducer';
import { connect } from 'react-redux';
import * as _ from "lodash";
import ActivityCaptureModalPopUp from './ActivityCaptureModalPopUp';
import ActivitySuggestionModalPopUp from './ActivitySuggestionModalPopUp';
import Tour from 'reactour'
import { CapitalizeFirstLetter } from './utils/StringUtility';

const MySwal = withReactContent(alertPopUp)

export const creditUserPopUpData = (indian, amount, expiryDate) => {
    return ({
        title: `You have ${amount} unused credit points. Expiring on ${getFormattedDate(expiryDate)}.`,
        focusConfirm: false,
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: 'Claim Now',
        cancelButtonText: 'Later',
        allowOutsideClick: false,
    })
};
class Home extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            loginSuccess: authService.isAuthenticated(),
            userData: authService.getUserDetailsFromLocalStorage(),
            showAwardModal: false,
            yearData: {},
            showPublic: false,
            creditUserFlag: props?.creditUserFlag,
            marketingPopUpFlag: false,
            activityCaptureModalFlag: false,
            activitySuggestionFlag: false,
            activitySugestionData: [],
            isTourOpen: true
        };
    }

    onCreditUserPopUp = () => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/user/credit/get/available/data?userId=${authService.getUserDetailsFromLocalStorage()?.userId}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                const creditUserConfirm = async () => {
                    const swalval = await MySwal.fire(creditUserPopUpData(response.data.body?.indian, response.data.body?.amount, response.data.body?.expiryDate));
                    if (swalval && swalval.value === true) {
                        this.props.history.push({
                            pathname: '/wenaturalists-pro'
                        })
                    } else {
                        this.showAwardModal();
                    }
                };
                creditUserConfirm();
            } else {
                this.showAwardModal();
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getActivitySuggestionData = () => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/activity/suggestion/get?userId=${authService.getUserDetailsFromLocalStorage()?.userId}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response?.data?.message === 'Success!' && response?.data?.body) {
                let activitySugestionDataList = response?.data?.body?.suggestions?.filter((item) => (item !== "JOB_OPPORTUNITY" && item !== "NATURE_CONTENT_AND_MONETISATION" && item !== "EXPLORE_AND_TRENDING" && item !== "FUND_RAISE" && item !== "EXPLORE_DAILY_EDITION"));
                this.setState({
                    activitySugestionData: activitySugestionDataList?.map((data) => ({ selector: `[id=${data?.toLowerCase()}]`, content: CapitalizeFirstLetter(data?.toLowerCase()?.replace(/\_+/gi, " ")) })),
                    activitySuggestionFlag: true
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    showAwardModal = () => {
        //1728887395000 = Monday, 14 October 2024 11:29:59
        if (new Date().getTime() <= 1728887395000 && !this.state.userData?.peopleAwardFlag) {
            let userData = this.state.userData;
            userData.peopleAwardFlag = true;
            authService.updateUserData(userData);
            this.setState({
                showAwardModal: true
            }, () => {
                window.$("#peopleOfNatureAwardModal").modal("show");
            })
        }
    }

    onCloseAwardModal = () => {
        window.$("#peopleOfNatureAwardModal").modal("hide");
        this.setState({ showAwardModal: false })
    }

    onCloseActivityCaptureModal = () => {
        localStorage.removeItem("initialSignUp");
        window.$("#activityCaptureModal").modal("hide");
        this.setState({ activityCaptureModalFlag: false })
    }

    onCloseActivitySuggestionModal = () => {
        window.$("#activitySuggestionModal").modal("hide");
        this.setState({ activitySuggestionFlag: false, activitySugestionData: {} })
    }

    componentDidMount() {
        document.title = 'Explore a new world of Naturalists | WeNaturalists';

        window.$('.topDropdownMob .dropdown > a').on("click", function (e) {
            // var submenu = $(this);
            // $('.topDropdownMob .dropdown-menu').removeClass('show');
            // submenu.next('.topDropdownMob .dropdown-menu').addClass('show');
            e.stopPropagation();
            window.$(this).next('.dropdown-menu').toggleClass('show');
        });

        if (this.state.creditUserFlag) {
            const newUrl = `${window.location.pathname}`;
            window.history.replaceState({}, '', newUrl);

            /*****Marketing pop up function*****/
            this.setState({
                showAwardModal: true,
                marketingPopUpFlag: false
            })

            /*****Profile Completion Reminder function****/
            //this.props.setProfileCompletionReminderData({ userId: this.state?.userData?.userId });

            /***Credit User Pop up function****/
            //this.onCreditUserPopUp();
        }/* else {
            this.getActivitySuggestionData();
        } */

        setTimeout(() => {
            this.setState({ disableswipe: true });
        }, 15000)
    }

    componentWillReceiveProps(props) {
        // this.setState({
        //     activityCaptureModalFlag: true
        // })
        if (localStorage.getItem("initialSignUp")) {
            this.setState({
                activityCaptureModalFlag: true
            })
        } else if (this.state.creditUserFlag && props.profileCompletionReminderData?.userId) {
            this.setState({
                creditUserFlag: false
            }, () => {
                if (props.profileCompletionReminderData?.remind) {
                    window.$("#profCompletePop").modal("show");
                } else {
                    this.onCreditUserPopUp();
                }
            })
        }
    }

    swipeIcon = () => {
        return (
            !this.state.disableswipe && <div className="swipe-lft">
                <img src="images/App-SwipeIcon.svg" alt="" style={{ width: "90px" }} />
            </div>
        )
    }

    getYearData = (data) => {
        this.setState({
            yearData: data
        })
    }

    getShowInPublicData = (flag) => {
        this.setState({
            showPublic: flag
        })
    }

    closeTour = () => {
        this.setState({
            activitySuggestionFlag: false
        })
    }

    render() {
        const { showAwardModal, yearData, showPublic, creditUserFlag, marketingPopUpFlag, activityCaptureModalFlag, activitySuggestionFlag, activitySugestionData, steps, isTourOpen } = this.state;
        if (!this.state.loginSuccess) {
            return <Redirect to='/landing' />
        } else {
            return <div className="wrapper homepage">

                <Header />
                {/* <EndorsementPopUp/> */}

                <Tour
                    steps={activitySugestionData}
                    isOpen={activitySuggestionFlag}
                    onRequestClose={this.closeTour}
                    showNumber={false}
                />
                <main className="dgcontainer hm3col">
                    <div className="container">
                        <HomePageBadge pageType={"FEEDS"} getShowInPublicData={this.getShowInPublicData} />
                        <div className="row">
                            <LeftPanel getYearData={this.getYearData} creditUserFlag={creditUserFlag} onCreditUserPopUp={this.onCreditUserPopUp} />
                            {/*<Payment/>*/}
                            <CentralPanel />
                            <RightPanel pageType={"FEEDS"} showPublic={showPublic} />

                            {showAwardModal && <PeopleNatureAwardModal onCloseAwardModal={this.onCloseAwardModal} yearData={yearData} awardFlag={true} marketingPopUpFlag={marketingPopUpFlag} />}
                            {/* {activityCaptureModalFlag && <ActivityCaptureModalPopUp onCloseActivityCaptureModal={this.onCloseActivityCaptureModal} />} */}
                            {/* {activitySuggestionFlag && <ActivitySuggestionModalPopUp activitySugestionData={activitySugestionData} onCloseActivitySuggestionModal={this.onCloseActivitySuggestionModal} />} */}
                        </div>
                    </div>
                </main>
            </div>
        }
    }
}

const mapStateToProps = (state) => {
    return {
        profileCompletionReminderData: state.ProfileReducer?.profileCompletionReminderData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setProfileCompletionReminderData: (state) => dispatch(setProfileCompletionReminderDetails(state))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
